import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3811aa80: FaireBrandEntity = {
  token: "b_3811aa80",
  type: "brand",
  name: "Christian Art Gifts",
  avatarUrl:
    "https://cdn.faire.com/fastly/43fac6664bcbfe842d775407065ec206399f28efca2aede940fc747b6f4201c4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f142a584246ecf5a6ca69b24913c31fa927cf680ddbf59be5d80c31c33ee8b8d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/43fac6664bcbfe842d775407065ec206399f28efca2aede940fc747b6f4201c4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f142a584246ecf5a6ca69b24913c31fa927cf680ddbf59be5d80c31c33ee8b8d.png",
  location: "Bloomingdale, IL, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 1663,
  isTopShop: true,
  isInsider: true,
  description:
    "Our purpose is to celebrate what is good and true through the products we create. Our unique line of gifts offers countless ways to affirm a friendship, encourage a loved one, congratulate a success, love a neighbor or remind someone of their faith.\n\nFrom our distribution center in Bloomingdale, Illinois, we ship to customers around the world. Whether engaged in customer service, product design or shipping, we all serve together to permanently impact people's lives through our scripturally inspired products. If you want to share life-changing messages of hope, joy, love & truth, consider giving a gift from Christian Art Gifts.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:11.875Z",
    importedBy: "entity-db-cli",
  },
};
